import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { cartActions } from '../../reducers/storeCart';
import * as types from '../../types';
import styles from './GiftCheckbox.module.scss';

export default function GiftCardCurrencyNotice() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const shown = useSelector((state: types.AppState) => state.storeShop.cart.giftCardCurrencyNotice);

  if (!shown) {
    return null;
  }

  return (
    <div className={styles.notice} role="status">
      <span>{t('hardware_first_gift_card_currency_notice')}</span>
      <button
        className={styles.linkButton}
        onClick={() => dispatch(cartActions.dismissGiftCardCurrencyNotice())}
        type="button"
      >
        {t('dismiss')}
      </button>
    </div>
  );
}
